import { Component } from '@angular/core';
import { AlarmHistoryTableRowComponent } from '@components/alarm-history-table-row/alarm-history-table-row.component';

@Component({
    selector: 'app-alarm-history-table-row-wrap',
    templateUrl: './alarm-history-table-row-wrap.component.html',
    styleUrls: [
        './alarm-history-table-row-wrap.component.scss',
        '../alarm-table-row-wrap/alarm-table-row-wrap.component.scss',
    ],
    standalone: false
})
export class AlarmHistoryTableRowWrapComponent extends AlarmHistoryTableRowComponent {}
